import { useAppKitAccount } from '@reown/appkit/react';
import { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';

// Components
import Logo from './Logo/Logo';
import Seeds from '../Seeds/Seeds';
import WalletController from '../WalletController/WalletController';
import AdminPageLink from '../admin/AdminPageLink/AdminPageLink';

// Hooks
import { useAppSelector } from '../../store';

// Styles
import styles from './Header.module.scss';

const Header = () => {
  const { isConnected } = useAppKitAccount();
  const isTablet = useAppSelector(s => s.main.isTablet);
  const isAdmin = useAppSelector(s => s.main.isAdmin);
  const isReferralManager = useAppSelector(s => s.main.isReferralManager);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuRef = useRef(null);
  const burgerButtonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        burgerButtonRef.current &&
        !burgerButtonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <header className={styles.wrapper}>
      {isConnected && (isAdmin || isReferralManager) && <AdminPageLink />}
      <div className={styles.logoWrapper}>
        <Logo />
      </div>
      {isTablet ? (
        <>
          <div
            ref={burgerButtonRef}
            className={classNames(styles.burgerButton, { [styles.isMenuOpen]: isMenuOpen })}
            onClick={() => setIsMenuOpen(prev => !prev)}
          >
            <span className={styles.burgerLine}></span>
            <span className={styles.burgerLine}></span>
            <span className={styles.burgerLine}></span>
          </div>
          {isMenuOpen && (
            <div ref={menuRef} className={styles.menuWrapper}>
              <Seeds />
              {isConnected && <WalletController />}
            </div>
          )}
        </>
      ) : (
        <>
          <Seeds />
          {isConnected && <WalletController />}
        </>
      )}
    </header>
  );
};

export default Header;
